import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

const banners = [
    {
        image: './banner0.png',
        title: 'Seu próximo carro está aqui',
        subtitle: 'Veículos selecionados com as melhores condições',
        align: 'left'
    },
    {
        image: './banner1.png',
        title: 'Qualidade e confiança',
        subtitle: 'Compra e venda com procedência garantida',
        align: 'center'
    },
    {
        image: './banner2.png',
        title: 'Financiamento facilitado',
        subtitle: 'Aprovamos seu crédito rapidamente',
        align: 'right'
    }
];


export default function BannerCarousel() {
    return (
        <Swiper
            modules={[Autoplay]}
            autoplay={{ delay: 4000, disableOnInteraction: false }}
            loop
            className="w-full mt-24 md:mt-14"
        >
            {banners.map((banner, index) => (
                <SwiperSlide key={index} className="relative">
                    <img
                        src={banner.image}
                        alt={banner.title}
                        className="w-full object-contain"
                    />


                </SwiperSlide>

            ))}
        </Swiper>
    );
}
